import { mediaQuery } from '@noths/polaris-client-styles';
import { themeVariables } from '@noths/polaris-design-system-abstract-theme';
import { css } from 'styled-components';

import { BREAKPOINT_M } from 'src/components/molecules/HeroVideo/HeroVideo.styles';

const { colors, spacing } = themeVariables;

export const container = css`
  background: #000;
  inset: 0;
  position: fixed;
  /* Above the site header; matches MembershipActivationModal, the app's other full-screen modal. */
  z-index: 999;
`;

export const player = css`
  --controls: none;
  /*
   * Designer request: on small screens the video fills the screen, cropping into the centre.
   * Note the cost with the single 16:9 asset: a portrait phone shows only the central ~26% of
   * the frame's width, so the film must keep its subject centred. Large screens keep the
   * letterboxed full frame.
   */
  --media-object-fit: cover;

  height: 100%;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;

  ${mediaQuery(
    { min: BREAKPOINT_M },
    css`
      --media-object-fit: contain;
    `,
  )}
`;

const iconButton = css`
  align-items: center;
  background: var(${colors.surface.default});
  border: none;
  border-radius: 50%;
  color: var(${colors.content.default});
  cursor: pointer;
  display: flex;
  justify-content: center;
  position: absolute;
`;

export const controls = css`
  inset: 0;
  pointer-events: none;
  position: absolute;
  transition: opacity 400ms ease;

  /* Fade with visibility, not unmount, so keyboard and screen-reader users can still reach the
     controls; focus brings them straight back. */
  [data-controls-visible='false'] & {
    opacity: 0;
  }

  & > * {
    pointer-events: auto;
  }
`;

export const closeButton = css`
  ${iconButton}
  height: 48px;
  right: var(${spacing.md});
  top: var(${spacing.md});
  width: 48px;
`;

export const playPauseButton = css`
  ${iconButton}
  bottom: var(${spacing.md});
  height: 44px;
  left: var(${spacing.md});
  width: 44px;
`;

export const muteButton = css`
  ${iconButton}
  bottom: var(${spacing.md});
  height: 44px;
  right: var(${spacing.md});
  width: 44px;
`;

export const progressTrack = css`
  background: rgba(255, 255, 255, 0.2);
  bottom: 0;
  height: 4px;
  left: 0;
  position: absolute;
  right: 0;
`;

export const progressFill = css`
  background: rgba(254, 251, 247, 0.7);
  height: 100%;
`;

export const overlay = css`
  align-items: center;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  inset: 0;
  justify-content: center;
  position: absolute;
`;

export const overlayContent = css`
  display: flex;
  flex-direction: column;
  gap: var(${spacing.sm});
  max-width: 342px;
  padding: var(${spacing.md});
  width: 100%;
`;

export const overlayHeading = css`
  color: var(${colors.content.action});
  margin: 0 0 var(${spacing.xs});
  text-align: center;
`;
